var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoSnapchat = function SvgLogoSnapchat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "-0.75 -0.75 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.25 21.797a4.5 4.5 0 0 1-2.813-1.566 2.73 2.73 0 0 0-2.38-.76l-.6.104a1.228 1.228 0 0 1-1.426-1.519.787.787 0 0 0-.543-.937l-1.875-.385a.797.797 0 0 1-.104-1.49 11.4 11.4 0 0 0 2.41-1.35 1.275 1.275 0 0 0-.085-2.1l-1.153-.731a1.425 1.425 0 0 1-.431-1.97 1.5 1.5 0 0 1 2.034-.421l1.238.787v-3a5.756 5.756 0 0 1 11.503 0V9.45l1.238-.787a1.5 1.5 0 0 1 2.034.421 1.425 1.425 0 0 1-.431 1.97l-1.153.73a1.275 1.275 0 0 0-.085 2.1 11.4 11.4 0 0 0 2.41 1.35.797.797 0 0 1-.104 1.491l-1.875.384a.787.787 0 0 0-.543.938 1.228 1.228 0 0 1-1.397 1.51l-.6-.104a2.73 2.73 0 0 0-2.381.76 4.5 4.5 0 0 1-2.888 1.584"
  })));
};
export default SvgLogoSnapchat;